import React from 'react';
export function Footer() {
  return <footer className="bg-slate-950 text-slate-400 py-12 border-t border-slate-800" data-id="element-126">
      <div className="container mx-auto px-4 text-center max-w-2xl" data-id="element-127">
        <h4 className="text-white font-bold text-xl mb-4" data-id="element-128">🤝 CENTRALPACK™</h4>

        <p className="mb-6 text-sm leading-relaxed" data-id="element-129">
          El sistema N°1 para aprender Lenguaje de Señas Argentina de manera
          progresiva, práctica y adaptada a la vida real en Argentina.
          <br data-id="element-130" />
          <strong className="text-slate-300 mt-2 block" data-id="element-131">
            Porque comunicarse con una persona sorda no debería ser imposible
            para nadie.
          </strong>
        </p>

        <div className="flex flex-wrap justify-center gap-4 text-sm mb-8" data-id="element-132">
          <a href="mailto:packcentral23@gmail.com" className="hover:text-white transition-colors" data-id="element-133">
            📧 packcentral23@gmail.com
          </a>
          <span className="hidden sm:inline" data-id="element-134">·</span>
          <span className="hover:text-white transition-colors" data-id="element-135">
            📱 @centralpack.ar
          </span>
          <span className="hidden sm:inline" data-id="element-136">·</span>
          <span className="hover:text-white transition-colors" data-id="element-137">
            🌐 www.centralpack.shop
          </span>
        </div>

        <div className="text-xs text-slate-600 border-t border-slate-800 pt-8" data-id="element-138">
          <p className="mb-2" data-id="element-139">
            © CentralPack™ 2026 — Todos los derechos reservados. Prohibida la
            reproducción y redistribución sin autorización expresa.
          </p>
          <p className="italic" data-id="element-140">
            🤟 "La próxima vez que estés frente a una persona sorda, vas a poder
            comunicarte."
          </p>
        </div>
      </div>
    </footer>;
}